// GA4 funnel events — thin gtag wrapper (GA_TRACKING.md approach A′, no GTM).
// gtag comes from index.html's inline stub, so calls queue into dataLayer even
// before gtag.js loads; when the script is blocked (dev/CI/adblock) they are
// harmless no-ops against the local stub.
// Measurement ID must match the hardcoded tag in front/index.html.
const GA4_ID = "G-Y4QBM54F7W"

let _identifiedAs = null

export function track(name, params = {}) {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return
    window.gtag("event", name, params)
}

export function identify(userId) {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return
    const id = String(userId)
    if (id === _identifiedAs) return
    _identifiedAs = id
    // send_page_view: false — re-config must not emit an extra page_view.
    window.gtag("config", GA4_ID, { user_id: id, send_page_view: false })
}
